/**
 * G9 — Daisy's Town Map grant.
 *
 * Cartridge: DAISY hands over the TOWN MAP on the player's first visit
 * after the lab; the map-object in her room is permanently flag-hidden
 * (FLAG_HIDE_TOWN_MAP stays in INITIAL_HIDDEN_FLAGS — she IS the
 * acquisition path). Fires on dialogue close after her normal lines;
 * possession is the once-only latch (the map is never consumed, so
 * hasItem is sufficient — no dedicated flag).
 */
import type { Handler } from '../scriptRunner';

export const DAISY_SCRIPT_REF = 'PalletTown_RivalsHouse_EventScript_Daisy';

export const daisyTownMapHandler: Handler = (ctx) => {
  if (ctx.runState.hasItem('town_map')) return;
  ctx.runState.addItem('town_map');
  ctx.audio.playSfx('item_get');
  ctx.worldScene.save();
  ctx.worldScene.showDialogue(
    ['You received the TOWN MAP!', 'DAISY: Check it from the BAG anytime.'],
    null,
  );
};
